export default __webpack_public_path__ + "static/media/logo.0657ce38.png";